import React from "react";

interface IProps {
  width?: number;
  height?: number;
  viewBox?: string;
  fill?: string;
  color?: string;
}

const ArrowExpandIcon: React.FC<IProps> = (props) => {
  const { width = 24, height = 24, viewBox = "", fill = "none", color = "black" } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox={!!viewBox ? viewBox : "0 0 24 24"}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 21V19H6.41L10.91 14.5L9.5 13.09L5 17.59V14H3V21H10ZM14.5 10.91L19 6.41V10H21V3H14V5H17.59L13.09 9.5L14.5 10.91Z"
        fill={color}
      />
    </svg>
  );
};

export default ArrowExpandIcon;
